import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type FirmOffice } from "@/lib/types";
import { baseFastApiFirmRoute } from "./firm";

export function getFirmOfficesV1() {
  return authenticatedFastApiAxiosInstance
    .get<APIResponse<FirmOffice[]>>(`${baseFastApiFirmRoute}/offices`)
    .then((res) => res.data);
}

export function createFirmOfficeV1(
  data: Pick<
    FirmOffice,
    "label" | "street1" | "city" | "state" | "zipCode" | "country"
  > &
    Partial<FirmOffice>,
) {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<FirmOffice>>(`${baseFastApiFirmRoute}/offices`, data)
    .then((res) => res.data);
}

export function updateFirmOfficeV1(
  data: Pick<FirmOffice, "id" | "dateModified"> & Partial<FirmOffice>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<FirmOffice>>(`${baseFastApiFirmRoute}/offices`, data)
    .then((res) => res.data);
}

export function deleteFirmOfficeV1(data: { id: string }) {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<FirmOffice>>(`${baseFastApiFirmRoute}/offices/${id}`)
    .then((res) => res.data);
}
// #endregion ----------- END Firm Office API requests -----------------
